import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ReusableForm from '../../components/ReusableForm';
import '../styles/FormPageStyles.css';
import { solicitarCambioContrasena } from '../../services/Auth/forgotPasswordServer';
import projectLogo from '../../public/Logo.png';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    if (!email) {
      setError('Por favor, introduce tu correo electrónico.');
      return;
    }

    try {
      const response = await solicitarCambioContrasena(email); 
      setSuccessMessage(response.message);
      // Esperar un momento para que el usuario vea el mensaje de éxito antes de redirigir
      setTimeout(() => {
        navigate('/auth/validate-code'); // Redirigir a la ruta correcta
      }, 2000); 

    } catch (err) {
      setError(err.message || 'Error al solicitar el cambio de contraseña.');
    }
  };

  const afterButtonLinks = (
    <div className="login-page-links-container">
      <div className="form-link-item">
        <p>
          ¿Recuerdas tu contraseña? <Link to="/auth/login" className="form-link">Inicia Sesión</Link>
        </p>
      </div>  
    </div>
  );

  return (
    <ReusableForm
      title="Cambiar Contraseña"
      imageSrc={projectLogo}
      error={error}
      successMessage={successMessage}
      handleSubmit={handleSubmit}
      submitButtonText="Enviar Solicitud"
      afterButtonContent={afterButtonLinks}
    >
      <div className="form-group">
        <input
          type="email"
          id="email"
          placeholder="Ingresa tu correo electrónico."
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="form-input"
        />
      </div>
    </ReusableForm>
  );
};

export default ForgotPasswordPage; 